import { strings } from "intl/fa";

export enum SubmitAdOrderErrors {
  ErrAccountIsNotActive = 100,
  ErrBothViewAndClickAreZero,
  ErrViewCountIsNotValid,
  ErrClickCountIsNotValid,
  ErrStartTimeIsNotValid,
  ErrUnSupportedSpot,
}

export const SubmitAdOrderErrorMessages = {
  [SubmitAdOrderErrors.ErrAccountIsNotActive]: "ErrAccountIsNotActive",
  [SubmitAdOrderErrors.ErrBothViewAndClickAreZero]:
    "ErrBothViewAndClickAreZero",
  [SubmitAdOrderErrors.ErrViewCountIsNotValid]: "ErrViewCountIsNotValid",
  [SubmitAdOrderErrors.ErrClickCountIsNotValid]: "ErrClickCountIsNotValid",
  [SubmitAdOrderErrors.ErrStartTimeIsNotValid]: "ErrStartTimeIsNotValid",
  [SubmitAdOrderErrors.ErrUnSupportedSpot]: "ErrUnSupportedSpot",
};

export enum GetPaymentTokenErrors {
  ErrServerNeedsHelp = 100,
  ErrAdHasAlreadyBeenPayed,
  ErrCodeIsNotAvailable,
  ErrCodeIsNotYours,
  ErrAdCannotBePayedFor,
  ErrCodeIsForFirstOrder,
  ErrTimeNotInPeriod,
  ErrPriceThresholdNotMet,
  ErrSegmentAlreadyFull,
  ErrNoMoreCapacityToday,
  ErrNeedToRetryReservation,
  ErrInvalidStartHour,
  ErrNeedShahkar,
  ErrInvalidCampaignPackageType,
  ErrCampaignPackageAlreadyExists,
  ErrMemberThresholdNotMet,
  ErrDiscountCellingNotMet,
  ErrCodeIsNotAvailableInThisSpot,
  ErrCodeUseCountFull,
  ErrCodeCapacityFull,
}

export const GetPaymentTokenErrorMessages: {
  [key in GetPaymentTokenErrors]: string;
} = {
  [GetPaymentTokenErrors.ErrServerNeedsHelp]:
    "سرور با مشکل مواجه شده است. لطفا با پشتیبانی تماس بگیرید.",
  [GetPaymentTokenErrors.ErrAdHasAlreadyBeenPayed]:
    "این سفارش قبلا پرداخت شده است.",
  [GetPaymentTokenErrors.ErrCodeIsNotAvailable]: "کد هدیه معتبر نیست.",
  [GetPaymentTokenErrors.ErrCodeIsNotYours]:
    "امکان استفاده از این کد هدیه برای شما وجود ندارد.",
  [GetPaymentTokenErrors.ErrAdCannotBePayedFor]:
    "امکان پرداخت برای این سفارش وجود ندارد.",
  [GetPaymentTokenErrors.ErrCodeIsForFirstOrder]:
    "کد هدیه فقط برای سفارش اول قابل استفاده است.",
  [GetPaymentTokenErrors.ErrTimeNotInPeriod]: "زمان شروع تبلیغ معتبر نیست.",
  [GetPaymentTokenErrors.ErrPriceThresholdNotMet]: "قیمت سفارش معتبر نیست.",
  [GetPaymentTokenErrors.ErrSegmentAlreadyFull]:
    "ظرفیت ساعت شروع انتخابی تکمیل است.",
  [GetPaymentTokenErrors.ErrNoMoreCapacityToday]:
    "ظرفیت نمایش تبلیغ برای روز انتخاب شده تکمیل است.",
  [GetPaymentTokenErrors.ErrNeedToRetryReservation]: "لطفا دوباره تلاش کنید.",
  [GetPaymentTokenErrors.ErrInvalidStartHour]: "ساعت شروع انتخابی معتبر نیست.",
  [GetPaymentTokenErrors.ErrNeedShahkar]: "ابتدا باید احراز هویت کنید",
  [GetPaymentTokenErrors.ErrInvalidCampaignPackageType]: "نوغ پکیج اشتباه است.",
  [GetPaymentTokenErrors.ErrCampaignPackageAlreadyExists]:
    "پکیج کمپین انتخابی قبلاً ثبت شده است.",
  [GetPaymentTokenErrors.ErrMemberThresholdNotMet]:
    "تعداد اعضا رعایت نشده است.",
  [GetPaymentTokenErrors.ErrDiscountCellingNotMet]:
    "سقف کد هدیه رعایت نشده است.",
  [GetPaymentTokenErrors.ErrCodeIsNotAvailableInThisSpot]:
    strings.bonus_code_errors.sponsored_wrong_ad_placement,
  [GetPaymentTokenErrors.ErrCodeUseCountFull]:
    strings.bonus_code_errors.used_before,
  [GetPaymentTokenErrors.ErrCodeCapacityFull]:
    strings.bonus_code_errors.full_capacity,
};

export enum SubmitBusinessAdOrderErrors {
  InternalError = 50,
}

export const SubmitBusinessAdOrderErrorMessages = {
  [SubmitBusinessAdOrderErrors.InternalError]: "InternalError",
};

export enum CampaignErrors {
  ErrNotSupportedFeature = 100,
  ErrZeroCredit,
  ErrInvalidChangeState,
  ErrTooManyActiveCampaigns,
  ErrNoMoreDailyCapacity,
  ErrCreditNotAvailableNow,
  ErrNoAvailableCustomCampaign,
  ErrInvalidEditCampaignAd,
  ErrMinCampaignStopValueNotMet,
  ErrMaxCampaignStopValueNotMet,
}

type CampaignErrorMessagesType = {
  [key in CampaignErrors]: string;
};

export const CampaignErrorMessages: CampaignErrorMessagesType = {
  [CampaignErrors.ErrInvalidChangeState]: "درخواست شما معتبر نمی‌باشد",
  [CampaignErrors.ErrZeroCredit]: "اعتبار شما کافی نیست",
  [CampaignErrors.ErrNotSupportedFeature]:
    "امکان ساخت کمپین برای شما وجود ندارد",
  [CampaignErrors.ErrTooManyActiveCampaigns]:
    "امکان فعال‌سازی کمپین جدید برای شما وجود ندارد",
  [CampaignErrors.ErrNoMoreDailyCapacity]:
    "ظرفیت نمایش روزانۀ کمپین‌های شما به اتمام رسیده است. برای فعالسازی مجدد کمپین‌ها، فردا مراجعه کنید.",
  [CampaignErrors.ErrCreditNotAvailableNow]:
    "اعتبار شما در حال حاضر قابل استفاده نیست",
  [CampaignErrors.ErrNoAvailableCustomCampaign]:
    "هیچ کمپین سفارشی فعالی برای شما وجود ندارد",
  [CampaignErrors.ErrInvalidEditCampaignAd]: "تبلیغ مورد نظر معتبر نیست",
  [CampaignErrors.ErrMinCampaignStopValueNotMet]:
    "مقدار توقف کمیپن باید بزرگتر باشد.",
  [CampaignErrors.ErrMaxCampaignStopValueNotMet]:
    "مقدار توقف کمپین باید کوچکتر باشد.",
};

export enum GetAvailableCampaignStartDateErrors {
  InternalError = 50,
}

export const GetAvailableCampaignStartDateErrorMessages = {
  [GetAvailableCampaignStartDateErrors.InternalError]: "InternalError",
};

export enum GetDefaultCampaignPackagesErrors {}

export enum GetCampaignPaymentTokenErrors {
  ErrServerNeedsHelp = 100,
  ErrAdHasAlreadyBeenPayed,
  ErrCodeIsNotAvailable,
  ErrCodeIsNotYours,
  ErrAdCannotBePayedFor,
  ErrCodeIsForFirstOrder,
  ErrTimeNotInPeriod,
  ErrPriceThresholdNotMet,
  ErrSegmentAlreadyFull,
  ErrNoMoreCapacityToday,
  ErrNeedToRetryReservation,
  ErrInvalidStartHour,
  ErrNeedShahkar,
  ErrInvalidCampaignPackageType,
  ErrCampaignPackageAlreadyExists,
}

// TODO:
export const GetCampaignPaymentTokenErrorMessages = {
  [GetPaymentTokenErrors.ErrServerNeedsHelp]:
    "سرور با مشکل مواجه شده است. لطفا با پشتیبانی تماس بگیرید.",
  [GetPaymentTokenErrors.ErrAdHasAlreadyBeenPayed]:
    "این سفارش قبلا پرداخت شده است.",
  [GetPaymentTokenErrors.ErrCodeIsNotAvailable]: "کد هدیه معتبر نیست.",
  [GetPaymentTokenErrors.ErrCodeIsNotYours]:
    "امکان استفاده از این کد هدیه برای شما وجود ندارد.",
  [GetPaymentTokenErrors.ErrAdCannotBePayedFor]:
    "امکان پرداخت برای این سفارش وجود ندارد.",
  [GetPaymentTokenErrors.ErrCodeIsForFirstOrder]:
    "کد هدیه فقط برای سفارش اول قابل استفاده است.",
  [GetPaymentTokenErrors.ErrTimeNotInPeriod]: "زمان شروع تبلیغ معتبر نیست.",
  [GetPaymentTokenErrors.ErrPriceThresholdNotMet]: "قیمت سفارش معتبر نیست.",
  [GetPaymentTokenErrors.ErrSegmentAlreadyFull]:
    "ظرفیت ساعت شروع انتخابی تکمیل است.",
  [GetPaymentTokenErrors.ErrNoMoreCapacityToday]:
    "ظرفیت نمایش تبلیغ برای روز انتخاب شده تکمیل است.",
  [GetPaymentTokenErrors.ErrNeedToRetryReservation]: "لطفا دوباره تلاش کنید.",
  [GetPaymentTokenErrors.ErrInvalidStartHour]: "ساعت شروع انتخابی معتبر نیست.",
  [GetPaymentTokenErrors.ErrNeedShahkar]: "ابتدا باید احراز هویت کنید",
  [GetPaymentTokenErrors.ErrInvalidCampaignPackageType]:
    "سرور با مشکل مواجه شده است. لطفا با پشتیبانی تماس بگیرید.",
  [GetPaymentTokenErrors.ErrCampaignPackageAlreadyExists]:
    "اعتبار پکیج قبلی شما پایان نیافته است.",
};

export enum GetUserCustomCampaignPackageErrors {
  ErrServerNeedsHelp = 100,
  // NoAvailableCustomCampaign = 106,
}
export enum GetAdJoinReportError {
  ErrServerNeedsHelp = 100,
}
export const GetUserCustomCampaignPackageErrorsMessages = {
  [GetUserCustomCampaignPackageErrors.ErrServerNeedsHelp]:
    "سرور با مشکل مواجه شده است. لطفا با پشتیبانی تماس بگیرید.",
  // [GetUserCustomCampaignPackageErrors.NoAvailableCustomCampaign]:
  //   "no available custom campaign",
};
